import { reducerWithInitialState } from 'typescript-fsa-reducers'

import CommentState from '../states/CommentState'
import { Comment } from '../actions'

export const initialState: CommentState = {
  comments: {}
}

export default reducerWithInitialState(initialState)
  .case(Comment.loadPhotoComments.done, (state, payload) => ({
    ...state,
    comments: {
      ...state.comments,
      [payload.params]: payload.result
    }
  }))
  .case(Comment.postPhotoComment.done, (state, payload) => ({
    ...state,
    comments: {
      ...state.comments,
      [payload.params.id]: [
        ...state.comments[payload.params.id],
        payload.result
      ]
    }
  }))
  .build()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/comment.ts